import { Select, SelectContent, SelectItem, SelectTrigger } from 'src/components/ui/select';
import { clsx } from 'clsx';
import React from 'react';
import { Controller } from 'react-hook-form';

export const SystemPromptTemplateSelect = ({
  name = 'template_id',
  control = undefined,
  onChange = (() => {}) as (option?: any) => void,
  options,
  readonly = true,
}: {
  name?: string;
  control?: any;
  onChange?: (option?: any) => void;
  options: any;
  readonly?: boolean;
}) => {
  const [open, setOpen] = React.useState(false);

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange: onSelectChange }, fieldState: { error } }) => {
        return readonly ? (
          <div
            className={
              'bg-light rounded-sm-5 px-2.5 py-1 text-sm text-ebony_opacity_80 font-medium'
            }
          >
            {options.find((option) => `${option.id}` === value)?.name || 'Custom'}
          </div>
        ) : (
          <Select
            // defaultValue={value}
            value={value}
            open={open}
            onOpenChange={setOpen}
            onValueChange={(val) => {
              if (val) {
                const option = options.find((option) => option.id === val);

                onSelectChange(val);
                onChange && onChange(option);
              }
            }}
          >
            <SelectTrigger className="w-full bg-white border border-[#E3E6E8] rounded-sm-5 px-2.5 py-1 gap-5 text-sm font-medium text-ebony_opacity_80 min-h-7.5">
              <div>
                <p
                  className={clsx(
                    'text-sm font-medium',
                    options.find((option) => `${option.id}` === value) && 'text-ebony',
                  )}
                >
                  <span>
                    {options.find((option) => `${option.id}` === value)?.name || 'Custom'}
                  </span>
                </p>
              </div>
            </SelectTrigger>
            <SelectContent className={'bg-light'}>
              {options.map((option) => {
                return (
                  <SelectItem
                    className={'px-4 rounded-none bg-white hover:!bg-[#a498ff1a]'}
                    key={option.id}
                    value={option.id}
                    indicatorHidden
                  >
                    <div className="flex flex-col">
                      <div className="flex gap-2 items-center">
                        <p
                          className={clsx(
                            'text-sm text-start relative',
                            `${option.id}` === value ? 'font-semibold' : 'font-medium',
                          )}
                        >
                          <span>{option.name}</span>
                        </p>
                      </div>
                    </div>
                  </SelectItem>
                );
              })}
              <SelectItem
                className={'hidden px-3 py-3 rounded-none bg-white hover:!bg-[#a498ff1a]'}
                value={'custom'}
                indicatorHidden
              >
                <div className="flex flex-col">
                  <div className="flex gap-2 items-center">
                    <p
                      className={clsx(
                        'text-sm text-start relative first-letter:capitalize',
                        value === 'custom' ? 'font-semibold' : 'font-medium',
                      )}
                    >
                      <span>Custom</span>
                    </p>
                  </div>
                </div>
              </SelectItem>
            </SelectContent>
          </Select>
        );
      }}
    />
  );
};
